"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BotFlowController = function () {
  function BotFlowController(BotFlowService, MermaidService, $scope, $q) {
    "ngInject";

    (0, _classCallCheck3.default)(this, BotFlowController);
    this.botFlowService = BotFlowService;
    this.mermaidService = MermaidService;
    this.$scope = $scope;
    this.$q = $q;
  }

  (0, _createClass3.default)(BotFlowController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.mermaidService.init();

      this.isLoading = true;

      var botFlowsPromise = this.botFlowService.getBotFlowsPromise();

      this.$q.all([botFlowsPromise]).then(function (data) {
        var _data = (0, _slicedToArray3.default)(data, 1),
            botsFlowsResponse = _data[0];

        _this.isLoading = false;

        _this.initializeFlows(botsFlowsResponse);
      });
    }
  }, {
    key: "initializeFlows",
    value: function initializeFlows(flowGroups) {
      var _this2 = this;

      var items = [];
      flowGroups.data.forEach(function (flowGroup) {
        var childItems = [];
        flowGroup.botFlows.forEach(function (botFlow) {
          childItems.push({
            id: botFlow.id,
            text: botFlow.title,
            flowChart: botFlow.flowChart
          });
        });

        items.push({
          text: flowGroup.title,
          expanded: true,
          items: childItems
        });
      });

      this.treeViewOptions = {
        dataSource: [{
          text: "Bot Flows",
          expanded: true,
          items: items
        }],
        select: function select(e) {
          return _this2.onTreeViewSelect(e);
        }
      };
    }
  }, {
    key: "onTreeViewSelect",
    value: function onTreeViewSelect(e) {
      var treeview = $("#bot-flow-tree-view").data("kendoTreeView");
      var dataItem = treeview.dataItem(e.node);

      if (dataItem.id) this.renderGraph(dataItem);
    }
  }, {
    key: "renderGraph",
    value: function renderGraph(dataItem) {
      this.setHeader(dataItem.text);
      var id = dataItem.id;
      var graphData = dataItem.flowChart;

      this.mermaidService.render("graph-" + id, graphData, function (svg, bindingFunctions) {
        document.getElementById("bot-flow-graph").innerHTML = svg;
      });
    }
  }, {
    key: "setHeader",
    value: function setHeader(header) {
      var _this3 = this;

      setTimeout(function () {
        _this3.header = header;
        _this3.$scope.$apply();
      }, 0);
    }
  }]);
  return BotFlowController;
}();

exports.default = BotFlowController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/bot-flow/bot-flow.controller.js
 **/